import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import { RouteModules } from '../../enums/route-modules.enum';
import { JwtLegFiClaims } from '../../services/auth/jwt-legfi-claims.model';
import { GrowlerService } from '../../components/shared/growler/growler.service';

@Injectable()
export class PermissionsGuard
{
    constructor(
            private _router: Router,
            private _growler: GrowlerService,
    ) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();

        const dashboardView: string[] = [];
        if (LegFiJwtService.featureEnabled('pmc-dashboard.enabled')) {
            dashboardView.push(`pmc/${jwt.pmcId}/dashboard`);
        } else if (jwt?.admin) {
            dashboardView.push('app/organization/dashboard');
        } else {
            dashboardView.push('app/owner/dashboard');
        }
        dashboardView.push(<any>{uri: encodeURIComponent(state.url)});

        if (jwt === null) {
            const loginView = ['/auth/login'];
            loginView.push(<any>{uri: encodeURIComponent(state.url)});
            return this._router.navigate(loginView);
        }

        // no module for permissions specified, all users pass
        if (!next.data.module) {
            return true;
        }

        if (next.data.hasOwnProperty('feature')) {
            // support check for feature enabled or disabled
            const featureCheck = next.data.feature.includes('!')
                ? LegFiJwtService.featureEnabled(next.data.feature)
                : !LegFiJwtService.featureEnabled(next.data.feature);

            if (featureCheck) {
                // allow supers into pmc dashboard
                if (next.data.feature === 'pmc-dashboard.enabled' && jwt.superUser) {
                    return true;
                }

                this._growler.oops('You are not authorized to view the requested feature');
                // redirect if no checks pass
                return this._router.navigate(dashboardView);
            }
        }

        if (next.data.module === RouteModules.SUPER_ADMIN) {
            if (jwt.superUser) {
                return true;
            }
        }

        if (next.data.module === RouteModules.ORG_ADMIN) {
            if (jwt.admin || jwt.superUser) {
                return true;
            }
        }

        const requireWrite = next.data.hasOwnProperty('write') && next.data.write === true;
        if (LegFiJwtService.doesUserHaveModulePermission(next.data.module, requireWrite)) {
            return true;
        }


        this._growler.oops('You are not authorized to view the requested page');
        // redirect if no checks pass
        return this._router.navigate(dashboardView);
    }
}
